export const collapseEventTarget = new EventTarget();
export const COLLAPSE_STATE_CHANGED = 'collapseStateChanged';

export const readCollapseStates = storageKey => {
  try {
    const raw = sessionStorage.getItem(storageKey);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const writeCollapseState = (storageKey, sectionId, isOpen) => {
  try {
    const existing = readCollapseStates(storageKey) || {};
    sessionStorage.setItem(storageKey, JSON.stringify({ ...existing, [sectionId]: isOpen }));
  } catch (_e) {
    // graceful degradation when storage is unavailable
  }
};

export const expandSection = (storageKey, sectionId) => {
  writeCollapseState(storageKey, sectionId, true);
  collapseEventTarget.dispatchEvent(
    new CustomEvent(COLLAPSE_STATE_CHANGED, { detail: { storageKey, sectionId, isOpen: true } })
  );
};
